import TextBubble from "../../TextBubble/TextBubble";
import bannerImg from "../../../assets/tournamentbanner.png";
import { useState, useEffect } from "react";
import { fetchTournamentRegisteredData } from "../../../fetchFromDB";
import "./TournamentPage.css"
import ExternalLink from "../../ExternalLink/ExternalLink";

export default function TournamentPage() {
    const [tournamentRegisteredData, setTournamentRegisteredData] = useState(null);
    
        useEffect(() => {
            const loadData = async () => {
                try {
                    const data = await fetchTournamentRegisteredData();
                    setTournamentRegisteredData(data);
                } catch (error) {
                    console.error("Failed to load events", error);
                }
            };
            loadData();
        }, []);

    return (
        <div>
            <div className="tournament-page-image-wrapper">
                <img src={bannerImg} alt="Tournament banner" />
            </div>
            <h1>2026 Heart of America Riichi Tournament</h1>
            <p>
                We are  happy to announce the first annual Riichi Open tournament in the Heart of America-
                Kansas City, Missouri! Join us for a weekend of competitive riichi mahjong as we bring together
                players from across the region and beyond! This historic event marks a milestone for the Midwest
                Riichi Mahjong community, offering players a chance to compete and connect.
                <br /><br />
                It will be held at the Residence Inn by Marriott, just four miles from the Kansas City
                International Airport! Experience Zona Rosa, one of Kansas City’s premier shopping and
                dining destinations, just less than two miles away!
            </p>
            <br />
            <TextBubble title="General Info" doLoadExpanded={false}>
                <div className="event-text-info">
                    <p>
                        <strong>[Tournament Dates]</strong>
                        <br />
                        May 30-31, 2026. (Saturday and Sunday)
                    </p>
                    <p>
                        <strong>[Location]</strong>
                        <br />
                        <ExternalLink href="https://maps.app.goo.gl/XpB9Da8atQfLArdr6">
                            Residence Inn Kansas City Airport
                        </ExternalLink>
                        <br />
                        10300 N Ambassador Dr, Kansas City, MO 6415
                        <br /><br />
                        <b>Parking</b>
                        <br />
                        $4 daily parking/ $13 overnight
                    </p>
                    <p>
                        <strong>[Entry Fee]</strong>
                        <br />
                        $65
                    </p>
                    <p>
                        <strong>[Player Cap]</strong>
                        <br />
                        52 Players
                    </p>
                    <p>
                        <strong>[Payment]</strong>
                        <br />
                        Paypal URL to be emailed once registration is complete.
                    </p>
                    <p>
                        <strong>[Communication]</strong>
                        <br />
                        Communication done via Discord. Link will be sent upon confirmation of registration.
                    </p>
                </div>
            </TextBubble>
            <br />
            <TextBubble title="Tournament Details" doLoadExpanded={false}>
                <div className="event-text-info">
                    <p>
                        <strong>[Ruleset]</strong>
                        <br />
                        <ExternalLink href="https://static1.squarespace.com/static/634a7884c297a25f06589b79/t/6834d67360e19c1da6c0d12c/1748293243651/WRC+Rules+2025.pdf">
                            WRC 2025
                        </ExternalLink>
                        <span> with </span>
                        <ExternalLink href="https://static1.squarespace.com/static/634a7884c297a25f06589b79/t/6361370e4ecf892aae92d39a/1667315470805/WRC+Optional+Rules+2022.pdf">
                            modifications
                        </ExternalLink>
                        :
                    </p>
                    <ol>
                        <li>Mod.2.1 Red Fives</li>
                        <li>Mod.6.3 Lower Penalties</li>
                    </ol>
                    <br />
                    <p>
                        <strong>[Tournament Format]</strong>
                        <br />
                        8 Hanchan FULL scramble– all handshuffled. Prizes and rankings will
                        be determined by your total score at the end of all 8 games. This
                        tournament is considered an open tournament, and any player from any
                        skill background can participate.
                    </p>
                    <p>
                        <strong>[Time]</strong>
                        <br />
                        All hanchans will last 75 minutes with no new hands after the timer has ended (75+0).
                    </p>
                    <p>
                        <strong>[Pairing System]</strong>
                        <br />
                        GoodEnoughGolfers
                    </p>
                    <p>
                        <strong>[Prize]</strong>
                        <br />
                        Trophies for top 4 and small prizes for 5th - 8th place.
                    </p>
                    <p>
                        <strong>[Schedule]</strong>
                    </p>
                    <div id="table-container">
                        <table className="event-schedule-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Saturday</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Check-in</td>
                                    <td>8:30 AM</td>
                                </tr>
                                <tr>
                                    <td>Announcements</td>
                                    <td>9:00 AM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 1</td>
                                    <td>9:30 AM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 2</td>
                                    <td>11:15 AM</td>
                                </tr>
                                <tr>
                                    <td>Lunch Break</td>
                                    <td>12:30 PM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 3</td>
                                    <td>2:15 PM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 4</td>
                                    <td>4:00 PM</td>
                                </tr>
                                <tr>
                                    <td>Free play</td>
                                    <td>5:30 PM</td>
                                </tr>
                                <tr>
                                    <td>Free play ends</td>
                                    <td>10:30 PM</td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="event-schedule-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Sunday</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Check-in</td>
                                    <td>8:30 AM</td>
                                </tr>
                                <tr>
                                    <td>Announcements</td>
                                    <td>9:00 AM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 1</td>
                                    <td>9:30 AM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 2</td>
                                    <td>11:15 AM</td>
                                </tr>
                                <tr>
                                    <td>Lunch Break</td>
                                    <td>12:30 PM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 3</td>
                                    <td>2:15 PM</td>
                                </tr>
                                <tr>
                                    <td>Hanchan 4</td>
                                    <td>4:00 PM</td>
                                </tr>
                                <tr>
                                    <td>Awards Ceremony</td>
                                    <td>5:30 PM</td>
                                </tr>
                                <tr>
                                    <td>Freeplay</td>
                                    <td>6:00 PM</td>
                                </tr>
                                <tr>
                                    <td>Freeplay ends</td>
                                    <td>10:00 PM</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    *Friday’s freeplay will begin at 2:00 PM all the way to 9:30 PM*
                </div>
            </TextBubble>
            <br />
            <TextBubble>
                {tournamentRegisteredData === null
                ? <p>Loading...</p>
                : tournamentRegisteredData.length > 51
                    ? <div>
                        <h1>Registration is full!</h1>
                        <br/>
                        <ExternalLink buttonType="wide" href="https://docs.google.com/forms/d/e/1FAIpQLSevNwHsOvbkKUjX4oXd3wIW4cVK6OMVyqi0B05AOKuwwy9IHw/viewform?usp=publish-editor">
                            Join the waitlist today!
                        </ExternalLink>
                        </div>
                    : <div className="event-text-info">
                        <p><strong>NOTE: </strong>Registration open January 1st, 2026, and will close on May 23rd.</p>
                        <ExternalLink buttonType="wide" href="https://docs.google.com/forms/d/e/1FAIpQLSccOQFcujcWERDnrEUQ0VgRlFvzjAn0mxZbc1yU2bV47cpgBQ/viewform?usp=dialog">
                            REGISTER HERE
                        </ExternalLink>
                    </div>}
            </TextBubble>
            <br />
            <TextBubble title="Registered">
                {tournamentRegisteredData === null
                ? <p>Loading...</p>
                : <>
                    <h3>Accepting {52 - tournamentRegisteredData.length} more players!</h3>
                    <table id="registered-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Club</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tournamentRegisteredData.map((user) => (
                                <tr key={user.uid}>
                                    <td>{user.first_name} {user.middle_name} {user.last_name}</td>
                                    <td>{user.club_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>}
            </TextBubble>
            <br />
            <p id="terms-and-policy-text">
                <strong>Tournament Terms:</strong>
                <br />
                All players must review and abide by the ARA Rules of Conduct.
                <br />
                Registration is considered complete only upon receipt of full payment.
                <br />
                By participating, players consent to photography/videography for promotional purposes.
                <br />
                Kansas City Riichi Mahjong LLC reserves the right to accept or deny any tournament registration.
                <br />
                All organizer decisions are final and at sole discretion.
                <br />
                Tournament entry fee includes Missouri sales tax.
                <br /><br />
                <strong>Refund Policy:</strong>
                <br />
                Refund requests must be submitted by <b>May 28th, 2026</b> and will be evaluated on a case-by-case basis.
                <br />
                Approved refunds may be subject to administrative processing fees.
            </p>
        </div>
    )
}